import { useState, type ReactNode } from 'react';

import { PatientScopeContext } from './patientScoped';

interface PatientScopeProviderProps {
  /** Identifies the scope. Changing it remounts `children` with fresh patient-scoped state. */
  scopeKey: string;
  children: ReactNode;
}

/**
 * Boundary for state defined with `definePatientScoped`. Wrap everything that
 * shows one patient, and pass a `scopeKey` that changes whenever that state
 * should be thrown away, such as on a patient switch.
 */
export function PatientScopeProvider({ scopeKey, children }: PatientScopeProviderProps) {
  return <PatientScope key={scopeKey}>{children}</PatientScope>;
}

function PatientScope({ children }: { children: ReactNode }) {
  const [instances] = useState(() => new Map<object, unknown>());
  return <PatientScopeContext.Provider value={instances}>{children}</PatientScopeContext.Provider>;
}
